import layout from '@/components/layout/layout'
import {localLanguageVal} from "@/utils/autoScale";
let localLanguage=localLanguageVal()
// console.log(localLanguageVal)
const home = {
  path: localLanguage+'/',
  name: 'home',
  redirect:localLanguage+'/',
  component: layout,
  children: [{
    path: '',
    redirect: '',
      name: 'home',
    component: () => import('@/views/home/home')
  },{
      path: localLanguage+'/sales',
      redirect: '',
      name: 'sales',
      component: () => import('@/views/sales/index')
  }]
}

export default home
